class VisitContact {
  constructor(visitId, carOwnerPhoneNumber, workshopPhoneNumber) {
    this.visitId = visitId;
    this.carOwnerPhoneNumber = carOwnerPhoneNumber;
    this.workshopPhoneNumber = workshopPhoneNumber;
  }
}

export default VisitContact;
